
import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    userId = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.org.myOrgRemoveUser, {
        userId,
    }, options);
    if (error) return { error, status };
    return content || {};
};
